import styled from 'styled-components';
import colors from 'styles/colors';

import { Link } from 'react-router-dom';
import { HeaderItem as TableHeaderItem } from 'styles/table';

export const HeaderItem = styled(TableHeaderItem)<{ sortable?: boolean; sortActive?: boolean }>`
  ${(props) => {
    let computedStyle = ``;

    if (props.sortable === false) {
      computedStyle = `
                  ${computedStyle}

                  i[class^="icon-sort"] {
                      display: none;
                  }
              `;
    } else {
      computedStyle = `
                      ${computedStyle}

                      cursor: pointer;
                  `;
    }

    if (props.sortActive) {
      computedStyle = `
                    ${computedStyle}

                    i[class^="icon-sort"] {
                        color: ${colors.tableText};
                    }
                `;
    }

    return computedStyle;
  }};
`;

export const Icon = styled.i`
  margin-left: 15px;
  font-size: 20px;
  color: ${colors.gray80};
  transition: 0.15s color linear;
`;

export const ColumnLink = styled(Link)`
  color: ${colors.highlight};
  text-decoration: none;
  transition: 0.15s color ease-in-out;

  &:hover {
    text-decoration: underline;
    color: ${colors.highlightActive};
  }
`;
